import compose from 'ramda/src/compose'
import equals from 'ramda/src/equals'
import not from 'ramda/src/not'

import fieldError from 'root/src/client/logic/form/selectors/fieldError'

export default compose(
	not,
	equals(''),
	fieldError,
)
